import type { TradeCycleVersion } from '@festina/unitlink-general-types/unitlink'
import { notEmpty, type OptionalArray } from '@festina-life/core'

export const assertNoDuplicateTradeCycleIds = (
  tradeCycleVersions: OptionalArray<TradeCycleVersion>,
) => {
  const tradeCycleIds = tradeCycleVersions
    ?.map((tradeCycle) => tradeCycle?.tradeCycleId)
    .filter(notEmpty)

  const isThereDuplicateTradeCycleIds =
    tradeCycleIds && new Set(tradeCycleIds).size !== tradeCycleIds.length

  if (isThereDuplicateTradeCycleIds) {
    throw new Error('Data is invalid: duplicate trade cycle IDs found.')
  }
}
